<ng-container *ngTemplateOutlet="(activeCategory === 'utilities' || selectedLeftNav?.id === 'utilities') && !app?.serviceId && package?.id && packageTemplate"></ng-container>
<ng-container *ngTemplateOutlet="app?.assetType === 'PACKAGE' && simplePackageTemplate"></ng-container>
<ng-container *ngTemplateOutlet="app?.assetType === 'ASSET' && appTemplate"></ng-container>
<ng-container *ngTemplateOutlet="app?.assetType === 'RECON' && reconTemplate"></ng-container>
<ng-container *ngTemplateOutlet="app?.assetType === 'BRIDGE_ASSET' && bridgeTemplate"></ng-container>

<ng-template #packageTemplate>
    <div class="package">
        <material-button buttonType="icon" [size]="'small'" prefixIcon="web_stories" [classList]="['packageIcon']"></material-button>
        <span class="packageName" [textContent]="package.id"></span>
    </div>
    <div class="packageApps" *ngIf="package.apps?.length > 0">
        <ng-container *ngFor="let app of package.apps; trackBy: trackById">
            <app-left-nav-apps-template (bridgeDialogOpen)="bridgeDialogOpen.emit($event)" (closeMenu)="closeMenu.emit();" [serviceId]="app.serviceId" (bridgeDialogOpen)="bridgeDialogOpen.emit($event)"></app-left-nav-apps-template>
        </ng-container>
    </div>
</ng-template>

<ng-template #simplePackageTemplate>
    <div class="groupTitleLayout relatedApps relative" AppSelection [app]="app" [title]="app.displayName" (click)="closeMenu.emit()">
        <div class="groupsContent">
            <div class="groupIconCircle" *transloco="let translate;">
                <img class="groupImg" src="/assets/images/folder.png" [alt]="translate('file')" />
            </div>
        </div>
        <span class="groupName" [textContent]="app.displayName"></span>
    </div>
</ng-template>

<ng-template #appTemplate>
    <div class="groupTitleLayout relatedApps relative" [title]="app.displayName" (click)="selectionEvent()">
        <div class="groupsContent">
            <div class="groupIconCircle" *transloco="let translate;">
                <img class="groupImg" src="/assets/images/file.png" [alt]="translate('file')" />
            </div>
        </div>
        <span class="groupName" [textContent]="app.displayName"></span>
        <div class="absolute top-1/2 -translate-y-1/2 right-0">
            <app-header-shortcuts [mainApp]="app"></app-header-shortcuts>
        </div>
    </div>
</ng-template>

<ng-template #reconTemplate>
    <div class="groupTitleLayout relatedApps" [title]="app.displayName" (click)="selectionEvent()">
        <div class="groupsContent">
            <div class="groupIconCircle">
                <mat-icon class="material-symbols-outlined reconIcon"> compare </mat-icon>
            </div>
        </div>
        <span class="groupName" [textContent]="app.displayName"></span>
    </div>
</ng-template>

<ng-template #bridgeTemplate>
    <div class="groupTitleLayout relatedApps" [title]="app.displayName" (click)='fetchBridgeAssets(app)'>
        <div class="groupsContent">
            <div class="groupIconCircle" *transloco="let translate;">
                <img class="groupImg" src="/assets/images/folder.png" [alt]="translate('folder')">
            </div>
        </div>
        <span class="groupName" [textContent]="app.displayName"></span>
    </div>
</ng-template>
